<template>
  <div
    id="echart-pie"
    style="width: 100%; height: 95%; margin-top: 3.5rem"
  ></div>
</template>
<script>
import MyApis from "../../../apis";
export default {
  name: "OpinionMedia",
  controller: "UI",
  action: "OpinionMedia",
  data() {
    return {
      loading: false,
      loadingText: "加载中...",
    };
  },
  mounted: function () {
    this.search();
  },
  methods: {
    search() {
      let that = this;
      let searchInfo = {
        BeginTime: new Date(new Date().getFullYear() + "-01" + "-01"),
        EndTime: new Date(),
      };
      new MyApis.OpinionApi()
        .GetMediaTop10(searchInfo)
        .then((r) => {
          r = r.data.Data;

          that.drawChart(r);
        })
        .catch((e) => {
          console.log(e);
          that.$message({
            type: "error",
            message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
          });
        });
    },
    drawChart(data) {
      if (data) {
        var legendData = [];
        var seriesData = [];
        for (var i = 0; i < data.length; i++) {
          var item = data[i];
          seriesData.push({
            name: item.WebSiteName,
            value: item.TotalCount,
          });
          legendData.push(item.WebSiteName);
        }
        // eslint-disable-next-line no-undef
        var myChart = echarts.init(document.getElementById("echart-pie"));
        var echartsColor = ["#2ac1ff","#e6a23c","#f56c6c","#67c23a","#cf9236","#257dd4","#91c7ae"]
        // eslint-disable-next-line no-undef
        var colors = echartsColor.slice(
          // eslint-disable-next-line no-undef
          parseInt((Math.random() * echartsColor.length) / 2)
        );
        myChart.setOption({
          color: colors,
          title: {
            show: false,
          },
          tooltip: {
            trigger: "item",
            formatter: "{b}: {d}%",
          },
          legend: {
            x: "center",
            y: "bottom",
            data: legendData,
            textStyle: { color: "#fff" },
          },
          toolbox: {
            show: true,
            feature: {
              mark: { show: true },
              dataView: { show: false, readOnly: false },
              magicType: {
                show: true,
                type: ["pie", "funnel"],
              },
            },
          },
          calculable: true,
          series: [
            {
              name: "数量",
              type: "pie",
              radius: "55%",
              avoidLabelOverlap: false,
              label: {
                normal: {
                  show: true,
                },
                emphasis: {
                  show: true,
                },
              },
              lableLine: {
                normal: {
                  show: false,
                },
                emphasis: {
                  show: true,
                },
              },
              data: seriesData,
            },
          ],
        });
      }
    },
  },
};
</script>